import React from "react";
import { Route } from "react-router-dom";
import Home from "../layouts/home/index";

const CallbackRoute = ({ children }) => {
    return <Home>{children}</Home>;
};
export default CallbackRoute;
